export default __webpack_public_path__ + "static/media/floral3.316d38d9.png";